import appConfig from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/logging';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'universal-cookie';
import { getDeviceType } from './get-device-type';

const cookies = new Cookies();
export const getCookie = (cookieName: string): any => cookies.get(cookieName);

const segmentTrackingLogger = getLogger('SegmentTracking');
const segmentAnalytics =
  appConfig?.SEGMENT?.WRITE_KEY && typeof window !== 'undefined'
    ? AnalyticsBrowser.load(
        {
          writeKey: appConfig?.SEGMENT?.WRITE_KEY, // this is a test value
          cdnURL: appConfig?.SEGMENT?.CDN_URL,
        },
        {
          cookie: {
            domain: appConfig?.SEGMENT?.DOMAIN,
            maxage: appConfig?.SEGMENT?.MAX_AGE,
            secure: appConfig?.SEGMENT?.SECURE,
          },
          integrations: {
            'Segment.io': {
              apiHost: appConfig?.SEGMENT?.API_HOST,
              protocol: appConfig?.SEGMENT?.PROTOCOL,
            },
          },
        }
      )
    : null;

export type DefaultPagePayload = {
  traditional_device_id: string;
  pageview_id: string;
  deployable_name: string;
  deployable_version: string;
};

export type DefaultImpressionPayload = {
  traditional_device_id: string;
  deployable_name: string;
  deployable_version: string;
};

export const trackSegmentTrackEvent = (
  eventName: string,
  pageViewId: string,
  eventProps: Record<string, any> = {}
): void => {
  const userAgent = typeof window !== 'undefined' ? navigator.userAgent : '';

  const device_type = getDeviceType(userAgent);

  const defaultPayload: DefaultImpressionPayload & { device_type: string } = {
    traditional_device_id: getCookie('cookie_id'),
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: appConfig?._meta?.version,
    device_type,
  };

  try {
    segmentAnalytics?.track(eventName, {
      pageview_id: pageViewId,
      ...defaultPayload,
      ...eventProps,
    });

    window?.dataLayer?.push({
      event: 'ShoppingFinished',
      ...eventProps,
    });
  } catch (e) {
    throw new Error(`segment error ${e}`);
    segmentTrackingLogger.error(e);
  }
};

export const trackInteraction = (
  eventName: string,
  eventProps: Record<string, any> = {}
): void => {
  const userAgent = typeof window !== 'undefined' ? navigator.userAgent : '';
  const device_type = getDeviceType(userAgent);

  try {
    segmentAnalytics?.track(eventName, {
      device_type,
      ...eventProps,
    });
  } catch (e) {
    throw new Error(`segment error ${e}`);
    segmentTrackingLogger.error(e);
  }
};

export const segmentImpressionId = uuidv4();
